export default __webpack_public_path__ + "static/media/phone_pe.b0d57713.png";